<template>
  <div class="designations">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Department Units</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Department Units</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a @click="openDialog" class="btn add-btn ml-1">
                  <i class="fa fa-plus"></i> Add Department Units
                </a>
                <a @click="openDialogImport" class="btn add-btn ml-1">
                  <i class="fa fa-plus"></i> Import Department Units
                </a>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-6">
              <div class="form-group form-focus">
                <input
                  type="text"
                  class="form-control floating"
                  v-model="filterDepartmentUnit"
                  style="height: 55px !important"
                />
                <label class="focus-label">Search Department Units</label>
              </div>
            </div>
          </div>
          <!-- /Search Filter -->

          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div
                class="alert alert-danger alert-dismissible fade show"
                role="alert"
                v-if="error"
              >
                <strong>Error!</strong> {{ error }}
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="col-md-12">
              <div class="table-responsive">
                <v-data-table
                  :headers="headers"
                  :items="searchDepartmentUnits"
                  sort-by="name"
                  class="elevation-1"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a
                          class="dropdown-item"
                          @click="setEditDesignation(item)"
                          ><i class="fa fa-pencil m-r-5"></i> Edit</a
                        >
                        <a
                          class="dropdown-item"
                          @click="setDeleteDesignation(item)"
                          ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </template>
                </v-data-table>
                <!-- <template v-slot:[`item.profile`]="{ item }">
        <h2 class="table-avatar blue-link">
                          <router-link to="/profile" class="avatar"
                            ><img alt="" src="../assets/profiles/avatar-02.jpg"
                          /></router-link>
                          <router-link to="/profile">{{
                            `${item.firstName}`
                          }}</router-link>
                        </h2>
      </template> -->

                <!-- <table class="table table-striped custom-table mb-0 datatable">
                  <thead>
                    <tr>
                      <th style="width: 30px;">#</th>
                      <th>Designation </th>
                      <th>Department </th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in designations" v-bind:key="item.id">
                      <td>{{index + 1}}</td>
                      <td>{{item.name}}</td>
                      <td>{{item.department.name}}</td>
                      <td class="text-right">
                        <div class="dropdown dropdown-action">
                          <a href="#" class="action-icon dropdown-toggle" data-toggle="dropdown"
                            aria-expanded="false"><i class="material-icons">more_vert</i></a>
                          <div class="dropdown-menu dropdown-menu-right">
                            <a class="dropdown-item" @click="setEditDesignation(item)" data-toggle="modal" data-target="#edit_designation"><i
                                class="fa fa-pencil m-r-5"></i> Edit</a>
                            <a class="dropdown-item" @click="setDesignation(item)" data-toggle="modal" data-target="#delete_designation"><i
                                class="fa fa-trash-o m-r-5"></i> Delete</a>
                          </div>
                        </div>
                      </td>
                    </tr>

                    
                    
                    
                   
                   
                    
                  </tbody>
                </table> -->
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->
        <!-- Add Department Units Modal -->
        <v-dialog v-model="dialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Department Unit</h5>
              <button type="button" class="close" @click="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="onSubmit">
                <div class="col-md-12">
                  <div
                    class="alert alert-danger alert-dismissible fade show"
                    role="alert"
                    v-if="error"
                  >
                    <strong>Error!</strong> {{ error }}
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
                <div class="col-md-12">
                  <div
                    class="alert alert-success alert-dismissible fade show"
                    role="alert"
                    v-if="message"
                  >
                    <strong>Success!</strong> {{ message }}
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
                <div class="form-group">
                  <label
                    >Department Unit Name
                    <span class="text-danger">*</span></label
                  >
                  <input
                    type="text"
                    v-model.trim="$v.name.$model"
                    id="name"
                    name="name"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.name.$error }"
                  />
                  <div
                    v-if="submitted && !$v.name.required"
                    class="invalid-feedback"
                  >
                    Department Unit Name is required
                  </div>
                  <!-- <input class="form-control" type="text"> -->
                </div>
                <div class="form-group">
                  <label>Department <span class="text-danger">*</span></label>
                  <select
                    id="department"
                    name="department"
                    class="form-control"
                    v-model.trim="$v.department.$model"
                    :class="{ 'is-invalid': submitted && $v.department.$error }"
                  >
                    <option disabled>Select Department</option>
                    <option
                      v-for="item in departments"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                  <div
                    v-if="submitted && !$v.department.required"
                    class="invalid-feedback"
                  >
                    Department is required
                  </div>
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="onSubmit"
                    class="btn btn-primary submit-btn"
                    data-dismiss="modal"
                    :disabled="submitted"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Add Department Unit Modal -->
        <!-- Edit Department Unit Modal -->
        <v-dialog v-model="dialogEdit" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Department Unit</h5>
              <button type="button" class="close" @click="closeEdit">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label
                    >Department Unit Name
                    <span class="text-danger">*</span></label
                  >
                  <input
                    type="text"
                    v-model="designation.name"
                    id="name"
                    name="name"
                    class="form-control"
                  />
                  <!-- <input class="form-control" type="text" v-model="departmentName" > -->
                </div>
                <div class="form-group">
                  <label>Department<span class="text-danger">*</span></label>
                  <select
                    id="department"
                    name="department"
                    class="form-control"
                    v-model="designation.departmentId"
                  >
                    <option disabled>Change Department</option>
                    <option
                      v-for="item in departments"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="updateDepartmentUnit"
                    class="btn btn-primary submit-btn"
                    data-dismiss="modal"
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Edit Department Unit Modal -->
        <!-- Delete Department Unit Modal -->
        <v-dialog v-model="dialogDelete" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Delete Department Unit</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      class="btn btn-primary continue-btn"
                      @click.prevent="deleteDepartmentUnit"
                      data-dismiss="modal"
                      >Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      @click="dialogDelete = false"
                      data-dismiss="modal"
                      class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Department Unit Modal -->
        <!-- Delete Employee Modal -->
        <v-dialog v-model="dialogImport" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Import Department Unit</h5>
              <button
                type="button"
                class="close"
                aria-label="Close"
                @click="closeImport"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div
                    class="alert alert-danger alert-dismissible fade show"
                    role="alert"
                    v-if="error"
                  >
                    <strong>Error!</strong> {{ error }}
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-header">
                <h3>Import Department Unit</h3>
                <p>
                  Download an excel template by clicking on the below button
                </p>
                <br />
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <p>
                    Note: please do not change the layout of the cells in the
                    excel, you are expected to add your data below the column
                    header (first row). <br />
                    Regards <strong>Department No</strong> column you are
                    expected to get the value from their representing sheet.
                    <br />
                  </p>
                </div>
                <div class="col-12">
                  <a
                    @click="downloadTemplate"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Download Template</a
                  >
                </div>
              </div>
              <hr />
              <hr />
              <div class="row">
                <div class="col-sm-9">
                  <div class="form-group">
                    <label>Upload File</label>
                    <div class="custom-file">
                      <input
                        type="file"
                        name="file"
                        class="form-control"
                        id="cv_upload"
                        @change="onFilePicked"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <a
                    @click="importUnit"
                    v-if="file"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Import</a
                  >
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Employee Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { required } from "vuelidate/lib/validators";
import { organizationService } from "@/services/organizationService";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },
  data() {
    return {
      dialog: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      headers: [
        { text: "Unit", value: "name" },
        { text: "Department", value: "department.name" },
        { text: "", value: "actions", sortable: false }
      ],
      filterDepartmentUnit: "",
      name: "",
      designations: [],
      designation: {},
      departments: [],
      department: null,
      submitted: false,
      loading: false,
      error: "",
      message: "",
      file: null,
      fileName: ""
    };
  },
  watch: {
    dialog(val) {
      val || this.openDialog();
    },
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogImport(val) {
      val || this.closeImport();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    }
  },

  computed: {
    searchDepartmentUnits: function() {
      return this.designations.filter(
        d =>
          d.name.toLowerCase().match(this.filterDepartmentUnit.toLowerCase()) ||
          d.department.name
            .toLowerCase()
            .match(this.filterDepartmentUnit.toLowerCase())
      );
    }
  },

  methods: {
    openDialog() {
      this.dialog = true;
      this.getDepartments();
    },
    openDialogImport() {
      this.dialogImport = true;
    },
    clearModel() {
      this.name = "";
      this.department = "";
      this.message = "";
      this.error = "";
      this.submitted = false
    },
    close() {
      this.dialog = false;
      this.clearModel();
    },
    onFilePicked(event) {
      const files = event.target.files;
      this.fileName = files[0].name;
      // console.log(this.fileName)
      this.file = files[0];
    },
    closeEdit() {
      this.dialogEdit = false;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    closeImport() {
      this.dialogImport = false;
    },
    setEditDesignation(model) {
      this.designation = model;
      this.dialogEdit = true;
    },
    setDeleteDesignation(model) {
      this.designation = model;
      this.dialogDelete = true;
    },
    getDepartmentUnits() {
      organizationService.getDepartmentUnits().then(
        model => {
          this.designations = model;
          console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    getDepartments() {
      organizationService.getDepartments().then(
        model => {
          this.departments = model;
          // console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    setDesignation(item) {
      this.designation = item;
    },
    updateDepartmentUnit() {
      this.submitted = true;

      this.loading = true;
      //console.log('department updated 1')
      organizationService.updateDepartmentUnit(this.designation).then(
        id => {
          organizationService.getDepartmentUnits().then(o => {
            this.designations = o;
            this.closeEdit();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    deleteDepartmentUnit() {
      const id = this.designation.id;
      organizationService.removeDepartmentUnit(id).then(
        id => {
          organizationService.getDepartmentUnits().then(o => {
            this.designations = o;
            this.dialogDelete = false;
          });
        },
        e => {
          this.error = "Department Unit being used in some information";
          this.dialogDelete = false;
        }
      );
    },
    downloadTemplate() {
      organizationService.downloadUnitTemplate().then(response => {
        let blob = new Blob([response.data], { type: response.data.type });
        // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, response.fileName);
        } else {
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); // Create a download link
          downloadElement.href = href;
          downloadElement.download = response.fileName; // Download the file name
          document.body.appendChild(downloadElement);
          downloadElement.click(); // click to download
          document.body.removeChild(downloadElement); // Download complete removal element
          window.URL.revokeObjectURL(href); // Release Blob object
        }
      });
    },
    importUnit() {
      organizationService.importDepartmentUnit(this.file).then(
        response => {
          organizationService.getDepartmentUnits().then(o => {
            (this.designations = o),
              // console.log(o),
              this.closeImport();
          });
        },
        error => {
          this.error = error;
        }
      );
    },
    onSubmit() {
      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.loading = true;

      organizationService.addDepartmentUnit(this.name, this.department).then(
        id => {
          this.message = "Department Unit added successfully ";
          //console.log(this.name, this.department)
          organizationService.getDepartmentUnits().then(o => {
            this.designations = o;
            this.close();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    }
  },
  validations: {
    name: { required },
    department: { required }
  },
  mounted() {
    this.getDepartments();
    this.getDepartmentUnits();

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    // Datatable

    // if ($('.datatable').length > 0) {
    //   $('.datatable').DataTable({
    //     "bFilter": false,
    //   });
    // }
    // if ($('.floating').length > 0) {
    //   $('.floating').on('focus blur', function (e) {
    //     $(this).parents('.form-focus').toggleClass('focused', (e.type === 'focus' || this.value.length > 0));
    //   }).trigger('blur');
    // }
  },
  name: "departmentunits"
};
</script>



// WEBPACK FOOTER //
// src/components/miscs/departmentunits.vue